function pluralize(count, singular, plural) {
  return count === 1 ? singular : plural ?? `${singular}s`;
}

export { pluralize };
//# sourceMappingURL=pluralize.mjs.map
